import React from "react"
import { Grid, Button } from "semantic-ui-react"
import { Link, Redirect } from "react-router-dom"
import { AskForConfirmation, Prompt } from "uikit"

export class Footer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      noPrompt: false,
      showConfirmation: false,
      deleteSucceeded: false
    }
  }

  handleDelete = async () => {
    this.setState({
      noPrompt: true
    })
    this.setState(
      {
        showConfirmation: false,
        deleteSucceeded: true
      },
      this.props.onDelete
    )
  }
  render = () => {
    const {
      isNew,
      deleteLabel,
      submitLabel,
      onSubmit,
      isModified,
      deleteText
    } = this.props
    if (this.state.deleteSucceeded) {
      return <Redirect to="/organize/accounts+property" />
    }
    return (
      <>
        {!!this.props.error ? (
          <Grid.Row style={{ background: "red", color: "white" }}>
            <Grid.Column textAlign="center">{this.props.error}</Grid.Column>
          </Grid.Row>
        ) : null}
        <Grid.Row style={{ borderTop: "1px solid #ccc" }} columns={2}>
          <Grid.Column textAlign="left" style={{ paddingLeft: "2em" }}>
            {isNew ? (
              <Link to="/organize/accounts+property">
                <Button basic content="Cancel" type="button" color="blue" />
              </Link>
            ) : (
              <Button
                basic
                type="button"
                color="red"
                onClick={() => this.setState({ showConfirmation: true })}
              >
                {deleteLabel}
              </Button>
            )}
            {this.state.showConfirmation ? (
              <AskForConfirmation
                onYes={this.handleDelete}
                onNo={() => this.setState({ showConfirmation: false })}
                header="Are You Sure?"
                render={() => <p>{deleteText}</p>}
              />
            ) : null}
          </Grid.Column>
          <Grid.Column textAlign="right" style={{ paddingRight: "2em" }}>
            <Button
              content={submitLabel}
              onClick={onSubmit}
              primary
              type="button"
            />
            <Prompt when={isModified} />
          </Grid.Column>
        </Grid.Row>
      </>
    )
  }
}
Footer.defaultProps = {
  submitLabel: "Yes",
  cancelLabel: "Cancel",
  modalContent: <strong> You cannot undo this action.</strong>
}
